declare const I18n;

import React from "react";
import ImagePickGroup from "./ImagePickGroup";
import CheckboxGroup from "./CheckboxGroup";
import RadioGroup from "./RadioGroup";
import BasicInputs from "./BasicInputs";
import RichTextBlock from "./RichTextBlock";
import ImageBlock from "./ImageBlock";

type ShowIfConfig = {
  key: string;
  equals: any;
};

type FieldConfig = {
  type: "image-pick" | "text" | "dropdown" | "radio" | "checkbox" | "password";
  label: string;
  description?: string;
  subLabel?: string;
  key: string;
  value: string;
  options?: string[] | "dynamic:years" | "dynamic:months";
  img?: string;
  icon?: string;
  maxLength?: number;
  minLength?: number;
  showIf?: ShowIfConfig;
};

type LayoutBlock =
  | { blockType: "richText"; props: { text: string } }
  | { blockType: "image"; props: { icon: string, imgUrl: string, maxWidth?: number } }
  | { blockType: "question"; props: { text: string } }
  | {
    blockType: "input";
    props: {
      allowMultipleSelection?: boolean;
      direction?: "row" | "column";
      fieldsPerColumn?: number;
      fields: FieldConfig[];
      fieldsGroupKey?: string;
    };
  };

type StepConfig = {
  type?: "image-pick" | "text" | "dropdown" | "radio" | string;
  question?: string;
  inputs?: Array<any>;
  inputGroup?: string;
  [k: string]: any;
};

type Props = {
  stepConfig: StepConfig;
  initialData: any;
  data: Record<string, any>;
  categories?: Array<{
    id: number;
    name: string;
    name_fr?: string;
    description?: string;
    description_fr?: string;
    icon_class?: string;
    slug: string;
  }>;
  onChange: (key: string, value: any, options?: { remove?: boolean }) => void;
  onNext: () => void;
};

const OnboardingForm: React.FC<Props> = ({
  stepConfig,
  initialData,
  data,
  categories,
  onChange,
  onNext,
}) => {
  if (!stepConfig) return null;

  return (
    <div className="onboarding-form-container">
      {stepConfig.layout.map((block, idx) => {
        switch (block.blockType) {
          case "richText":
            return <RichTextBlock key={`rich-${idx}`} block={block} />;

          case "image":
            return <ImageBlock key={`image-${idx}`} block={block} />;

          case "question":
            const text = block.props.textKey
              ? I18n.t(block.props.textKey)
              : block.props.text;
            return (
              <div
                key={`q-${idx}`}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: "1.2rem",
                  maxWidth: "60ch",
                  textAlign: "center",
                  paddingTop: "1.5em",
                }}
              >
                <h3 style={{ margin: 0 }}>{text}</h3>
              </div>
            );

          case "input":
            if (block.props.fields.some((f) => f.type === "image-pick")) {

              return (
                <ImagePickGroup key={`img-${idx}`} block={block} data={data} categories={categories} onChange={onChange} />
              );
            }

            if (block.props.fields.some((f) => f.type === "checkbox")) {
              return (
                <CheckboxGroup key={`chk-${idx}`} block={block} data={data} onChange={onChange} />
              );
            }

            if (block.props.fields.some((f) => f.type === "radio")) {
              return (
                <RadioGroup key={`rad-${idx}`} block={block} data={data} onChange={onChange} />
              );
            }

            return (
              <BasicInputs key={`inp-${idx}`} block={block} initialData={initialData} data={data} onChange={onChange} />
            );

          default:
            return null;
        }
      })}
    </div>
  );
};

export default OnboardingForm;
